import React from 'react'

import { ReactModal, Button } from '../../../../../components'
import { REPORT } from '../../../../../helpers/constants'

import {
  StyleHeader,
  StyleContent,
  StyleFooter,
} from './style'

const IssueManagementResponseModal = (props) => {
  const {
    isVisible,
    isError,
    language,
    onClose,
    colorTheme,
  } = props

  const header = isError ? REPORT.ERROR[language] : REPORT.SUCCESS[language]
  const detail = isError ? REPORT.ERROR_DETAIL[language] :REPORT.SUCCESS_DETAIL[language]

  return (
    <ReactModal
      isVisible={isVisible}
      width={416}
      borderRadius={16}
    >
      <StyleHeader>
        <label className='header-issue-modal'>{header}</label>
      </StyleHeader>

      <StyleContent>
        <label className='detail-issue-modal'>{detail}</label>
      </StyleContent>

      <StyleFooter colorTheme={colorTheme}>
        <Button
          name={REPORT.DONE[language]}
          className='done-button'
          onClick={onClose}
        />
      </StyleFooter>
    </ReactModal>
  )
}

export default IssueManagementResponseModal
